<mat-card>
  <mat-card-header>
    <mat-card-title>{{'menu_export_report.dialog_create.title' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "menu_export_report.general_info_entry" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" [formGroup]="searchForm" (ngSubmit)="onClickBtnFilter()" class="pb-3">
          <div class="row">
            <div class="col-3">
              <!-- Tên báo cáo -->
              <mat-form-field class="w-100">
                <input (focusout)="focusOut('reportName')" #focusInput matInput type="text"
                  [placeholder]="'menu_export_report.report_name' | translate" maxlength="255" autocomplete="off"
                  formControlName="reportName" />
                <button mat-button *ngIf="searchForm?.controls?.reportName?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('reportName')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-3">
              <!-- Trạng thái xuất báo cáo -->
              <mat-form-field class="w-100">
                <mat-select id="exportStatus" name="exportStatus"
                  [placeholder]="'menu_export_report.status_select.status_export' | translate"
                  formControlName="exportStatus">
                  <mat-option *ngFor="let itemSelect of listStatus" [value]="itemSelect.value">
                    {{ itemSelect.labelKey | translate }}
                  </mat-option>
                </mat-select>
                <button mat-button *ngIf="searchForm?.controls?.exportStatus?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('exportStatus')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-3">
              <!-- Trạng thái ký số -->
              <mat-form-field class="w-100">
                <mat-select id="signStatus" name="signStatus"
                  [placeholder]="'menu_export_report.status_select.signature_status' | translate"
                  formControlName="signStatus">
                  <mat-option *ngFor="let itemSelect of listSignatureStatus" [value]="itemSelect.value">
                    {{ itemSelect.labelKey | translate }}
                  </mat-option>
                </mat-select>
                <button mat-button *ngIf="searchForm?.controls?.signStatus?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('signStatus')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-3">
              <!-- Trạng thái gửi BNV -->
              <mat-form-field class="w-100">
                <mat-select id="sendMohaStatus" name="sendMohaStatus"
                  [placeholder]="'menu_export_report.status_select.send_status' | translate"
                  formControlName="sendMohaStatus">
                  <mat-option *ngFor="let itemSelect of listSendStatus" [value]="itemSelect.value">
                    {{ itemSelect.labelKey | translate }}
                  </mat-option>
                </mat-select>
                <button mat-button *ngIf="searchForm?.controls?.sendMohaStatus?.value" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearData('sendMohaStatus')">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <!-- Khởi tạo từ ngày -->
            <div class="col-3">
              <mat-form-field class="w-100" [class.mb-3]="valueSelect != 1">
                <mat-label>{{ 'menu_export_report.initialized_from_date' | translate }}
                  <span class="text-danger">*</span>
                </mat-label>
                <input matInput [matDatepicker]="createdFromDate" name="createdFromDate" [max]="searchForm.controls['createdToDate'].value || today"
                  [errorStateMatcher]="matcher"
                  (focus)="lastTouchedField = 'createdFromDate'; searchForm.updateValueAndValidity()"
                  (blur)="searchForm.controls['createdFromDate'].markAsTouched()"
                  (dateChange)="onDateInputChange('createdFromDate', pickerFromDateInput, searchForm.controls['createdFromDate'])"
                  (change)="onDateInputChange('createdFromDate', pickerFromDateInput, searchForm.controls['createdFromDate'])"
                  formControlName="createdFromDate"
                  [ngClass]="{ 'is-invalid': searchForm.controls['createdFromDate'].invalid }" maxlength="10"
                  #pickerFromDateInput />
                <mat-datepicker-toggle matSuffix [for]="createdFromDate"> <i matDatepickerToggleIcon
                    class="fa fa-calendar" aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i></mat-datepicker-toggle>
                <mat-datepicker #createdFromDate></mat-datepicker>
                <mat-error>
                  <span class="text-error">
                    {{ getErrorDateMessageV2(pickerFromDateInput.value, true, 'createdFromDate') }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Khởi tạo đến ngày -->
            <div class="col-3">
              <mat-form-field class="w-100" [class.mb-3]="valueSelect != 1">
                <mat-label>{{ 'menu_export_report.initialized_to_date' | translate }}
                  <span class="text-danger">*</span>
                </mat-label>
                <input matInput [matDatepicker]="createdToDate" name="createdToDate"        
                  [min]="searchForm.controls['createdFromDate'].value"
                  [max]="today"
                  [errorStateMatcher]="matcher"
                  (focus)="lastTouchedField = 'createdToDate'; searchForm.updateValueAndValidity()"
                  (blur)="searchForm.controls['createdToDate'].markAsTouched()"
                  (dateChange)="onDateInputChange('createdToDate', pickerToDateInput, searchForm.controls['createdToDate'])"
                  (change)="onDateInputChange('createdToDate', pickerToDateInput, searchForm.controls['createdToDate'])"
                  formControlName="createdToDate"
                  [ngClass]="{ 'is-invalid': searchForm.controls['createdToDate'].invalid }" maxlength="10"
                  #pickerToDateInput>
                <mat-datepicker-toggle matSuffix [for]="createdToDate"> <i matDatepickerToggleIcon
                    class="fa fa-calendar" aria-hidden="true"
                    [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i></mat-datepicker-toggle>
                <mat-datepicker #createdToDate></mat-datepicker>
                <mat-error>
                  <span class="text-error">
                    {{ getErrorDateMessageV2(pickerToDateInput.value, true, 'createdToDate') }}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button mat-stroked-button color="primary" type="submit">
                <mat-icon class="mr-0" style="font-weight: 900">
                  search
                </mat-icon>
                {{ "search_form.search" | translate }}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
          <span>
            {{ "menu_export_report.list_of_generated_reports" | translate }} ({{paginate.totalRow}})
          </span>
          <button mat-stroked-button style="font-weight: 700" color="primary" type="submit" (click)="onClickCreate()">
            <mat-icon class="mr-0" style="font-weight: 900">add</mat-icon>
            {{ "menu_export_report.create_report" | translate }}
          </button>
        </mat-panel-title>
        <div class="mat-table-container table-container example-container"
          style="display: block; max-height: 590px; overflow-x: auto;">
          <mat-table [dataSource]="listDataSource" matSort class="mat-table-col-extra-sm mat-table table"
            style="min-width: 1600px; width: 100%;">
            <!-- STT -->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                {{ "headertable.stt" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let i = index"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{ paginate.currentPage * paginate.pageSize + i + 1 }}
              </mat-cell>
            </ng-container>

            <!-- 1. Tên báo cáo -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 200px;">
                {{ "menu_export_report.table.report_name" | translate }}
              </mat-header-cell>

              <mat-cell *matCellDef="let element; let i = index" [matTooltip]="element.reportName"
                matTooltipClass="tooltip-break" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 200px; max-width: 200px; word-break: break-all;">

                <span class="fix-width fw-100 name nameToolTip"
                  style="display: block; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ element.reportName }}
                </span>
              </mat-cell>
            </ng-container>

            <!-- 2. Kỳ báo cáo -->
            <ng-container matColumnDef="reportPeriod">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 150px;">
                {{ "menu_export_report.table.report_period" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 150px;">
                {{ element.reportPeriod }}
              </mat-cell>
            </ng-container>

            <!-- 3. Năm báo cáo -->
            <ng-container matColumnDef="reportYear">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 120px;">
                {{ "menu_export_report.table.report_year" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 120px;">
                {{ element.reportYear }}
              </mat-cell>
            </ng-container>

            <!-- 4. Dữ liệu từ ngày - đến ngày -->
            <ng-container matColumnDef="dateRange">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 220px;">
                {{ "menu_export_report.table.date_range" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 220px;">
                {{ element.fromDate | date: 'dd/MM/yyyy' }} - {{ element.toDate | date: 'dd/MM/yyyy' }}
              </mat-cell>
            </ng-container>

            <!-- 5. Ngày báo cáo -->
            <ng-container matColumnDef="reportDate">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 150px;">
                {{ "menu_export_report.table.report_date" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 150px;">
                {{ element.reportDate | date: 'dd/MM/yyyy' }}
              </mat-cell>
            </ng-container>
            <!-- 6. Số lượng hợp đồng -->
            <ng-container matColumnDef="contractCount">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 150px;">
                {{ "menu_export_report.table.contract_quantity" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 150px;">
                {{ element.contractCount }}
              </mat-cell>
            </ng-container>

            <!-- 7. Thời gian tạo báo cáo -->
            <ng-container matColumnDef="createdTime">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 180px;">
                {{ "menu_export_report.table.created_date" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 180px;">
                {{ element.createdTime | date: 'dd/MM/yyyy HH:mm:ss' }}
              </mat-cell>
            </ng-container>

            <!-- 8. Trạng thái xuất báo cáo -->
            <ng-container matColumnDef="exportStatus">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 200px;">
                {{ "menu_export_report.table.export_status" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 200px;">
                <nz-tag *ngIf="+element.exportStatusCode === 2"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'menu_export_report.status_select.inprogress' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.exportStatusCode === 3"
                  [nzColor]="'red'" style="margin-right: 0px;">{{'menu_export_report.status_select.fail' | translate}}
                </nz-tag>
                <nz-tag *ngIf="+element.exportStatusCode === 4"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'menu_export_report.status_select.success' | translate}}
                </nz-tag>
              </mat-cell>
            </ng-container>          
            <!-- 9. Trạng thái ký số -->
            <ng-container matColumnDef="signStatus">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 200px;">
                {{ "menu_export_report.table.sign_status" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 200px;">
                <nz-tag *ngIf="+element.signStatusCode === 1"
                  style="margin-right: 0px;">
                  {{'menu_export_report.status_select.unsigned' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.signStatusCode === 2"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'menu_export_report.status_select.inprogress' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.signStatusCode === 3"
                  [nzColor]="'red'" style="margin-right: 0px;">{{'menu_export_report.status_select.fail' | translate}}
                </nz-tag>
                <nz-tag *ngIf="+element.signStatusCode === 4"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'menu_export_report.status_select.completed' | translate}}
                </nz-tag>
              </mat-cell>
            </ng-container>
            <!-- 10. Trạng thái gửi BNV -->
            <!-- <ng-container matColumnDef="sendMohaStatus">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 200px; background-color: #f5f5f5;">
                {{ "menu_export_report.table.send_bnv_status" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 200px;">
                {{ element.sendMohaStatus }}
              </mat-cell>
            </ng-container> -->
            <ng-container matColumnDef="sendMohaStatus">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                style="min-width: 200px;">
                {{ "menu_export_report.table.send_bnv_status" | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell"
                style="min-width: 200px;">
                <nz-tag *ngIf="+element.sendMohaStatusCode === 1"
                  style="margin-right: 0px;">
                  {{'menu_export_report.status_select.unsended' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.sendMohaStatusCode === 2"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'menu_export_report.status_select.sending' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.sendMohaStatusCode === 3"
                  [nzColor]="'red'" style="margin-right: 0px;">{{'menu_export_report.status_select.fail' | translate}}
                </nz-tag>
                <nz-tag *ngIf="+element.sendMohaStatusCode === 4"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'menu_export_report.status_select.completed' | translate}}
                </nz-tag>
              </mat-cell>
            </ng-container>
            <!-- Thao tác -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="text-center" style="min-width: 180px;">
                {{ "menu_export_report.action" | translate }}
              </mat-header-cell>

              <mat-cell *matCellDef="let element" class="text-center" style="min-width: 180px;">

                <!-- 1. Xem chi tiết (Xuất báo cáo = Thành công [4]) -->
                <button mat-icon-button type="button" (click)="viewReport(element.id)"
                [disabled]="element.exportStatusCode !== 4">
                  <mat-icon [matTooltip]="'cp.tooltips.view' | translate">visibility</mat-icon>
                </button>

                <!-- 2. Tải xuống (Xuất báo cáo = Thành công [4]) -->
                <button mat-icon-button type="button" (click)="onDownload(element)"
                [disabled]="element.exportStatusCode !== 4">
                  <mat-icon [matTooltip]="'tooltips.download' | translate">save_alt</mat-icon>
                </button>

                <button mat-icon-button type="button" (click)="deleteReport(element)"
                  [disabled]="element.signStatusCode === 4">
                  <i class="fa fa-trash" style="font-size: 20px;" aria-hidden="true"
                    [matTooltip]="'document_template.tooltip_delete' | translate"></i>
                </button>

                <!-- 4. Sao chép (Theo hàm logic shouldShowCopyButton) -->
                <button mat-icon-button type="button" (click)="copyReport(element.id)">
                  <mat-icon class="mr-0" [matTooltip]="'enterprise_contract.buttons.copy' | translate">
                    file_copy
                  </mat-icon>
                </button>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row">
            </mat-row>
          </mat-table>
        </div>
        <!-- Pagination -->
        <app-pagination class="my-pagination" [(paginate)]="paginate"
          (pageChange)="onPageChange($event.page, $event.pageSize)">
        </app-pagination>

      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>